export const BUSINESS_TYPE_SALE = '65';
export const BUSINESS_TYPE_REJECT = '66';